import { createAction } from 'redux-act';

export interface ISetScreenToShow {
	screen_to_show: string;
}

export const setScreenToShow = createAction<ISetScreenToShow>();
export const setRequiredScreenToShow = createAction<{ required_screen_to_show: string }>();